{
  "gousto_session_id": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores session id"
  },
  "v1_goustoStateStore_features": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores the list of feature flags"
  },
  "v1_goustoStateStore_tracking": {
    "category": "MARKETING",
    "userDescription": "Stores details of relevant marketing campaign for new customers"
  },
  "v1_goustoStateStore_promoAgeVerified": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores promocode validity"
  },
  "v1_goustoStateStore_basket_postcode": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores postcode for the current order in the basket"
  },
  "v1_goustoStateStore_basket_date": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores delivery date for the current order in the basket"
  },
  "v1_goustoStateStore_basket_address": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores delivery address for the current order in the basket"
  },
  "v1_goustoStateStore_basket_numPortions": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores number of portions for the current order in the basket"
  },
  "v1_goustoStateStore_basket_slotId": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores information on the delivery slot for the current order in the basket"
  },
  "v1_goustoStateStore_basket_recipes": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores recipes for the current order in the basket"
  },
  "v1_goustoStateStore_basket_promoCode": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores the promo code for the current order in the basket"
  },
  "v1_goustoStateStore_basket_subscriptionOption": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores subscription option for the current order in the basket"
  },
  "v1_goustoStateStore_menu_selectedRecipeVariants": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores details of ingredient swaps for the current order"
  },
  "v1_goustoStateStore_menu_curatedBoxName": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores details of a selected curated box"
  },
  "v1_goustoStateStore_menu_curatedBoxCollectionId": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores the ID of a selected curated box (box with pre-celected recipes)"
  },
  "v1_goustoStateStore_deliveryDetails_deliveryInstruction": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores delivery instructions"
  },
  "v1_goustoStateStore_deliveryDetails_deliveryInstructionCustom": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores custom delivery instructions"
  },
  "v1_cookie_app_promotion": {
    "category": "FUNCTIONALITY",
    "userDescription": "Remembers whether app banner promotion was viewed "
  },
  "v1_tutorial_viewed": {
    "category": "FUNCTIONALITY",
    "userDescription": "Remembers whether a user saw the menu tutorial"
  },
  "v1_oauth_expiry": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used for authentication purposes"
  },
  "v1_oauth_refresh": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used for authentication purposes"
  },
  "v1_oauth_remember": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used for authentication purposes"
  },
  "v1_oauth_token": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used for authentication purposes"
  },
  "v1_clientID": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores anonymous ID used for A/B testing"
  },
  "v1_gousto_cookie_consent": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Stores cookie preferences"
  },
  "__zlcmid": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used for chat widget authentication"
  },
  "_GRECAPTCHA": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used when reCAPTCHA is executed"
  },
  "AWSELBCORS": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "AWS Classic Load Balancer Cookie"
  },
  "AWSALB": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "AWS Classic Load Balancer Cookie"
  },
  "LANG": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "tsrce": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "datadome": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "ts": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "ts_c": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "cookie_prefs": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "rmuc": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "KHcl0EuY7AKSMgfvHl7J5E7hPtK": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "UGZUWCKM6F_awXE8WyEURJrBYQG": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "d_id": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "cookie_check": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "ddi": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "sc_f": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "enforce_policy": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "x-pp-s": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "nsid": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "TfXMWj95u2_Zf1Kmv_GCUOjlGG8": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "l7_az": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "ui-experience": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "This cookie is required for PayPal to function on our website"
  },
  "_dd_s": {
    "category": "ANALYTICS",
    "userDescription": "Used to monitor the website for errors or performance issues you might encounter"
  },
  "_ga": {
    "category": "ANALYTICS",
    "userDescription": "Used by Google Analytics to distinguish users"
  },
  "_ga_*": {
    "category": "ANALYTICS",
    "userDescription": "Used by Google Analytics to persist session state"
  },
  "_gclxxxx": {
    "category": "MARKETING",
    "userDescription": "Google Conversion tracking cookie"
  },
  "_gid": {
    "category": "ANALYTICS",
    "userDescription": "Used by Google Analytics to distinguish users"
  },
  "_gcl_au": {
    "category": "MARKETING",
    "userDescription": "Used to store and track conversions"
  },
  "_dc_gtm_*": {
    "category": "ANALYTICS",
    "userDescription": "Used to throttle request rate"
  },
  "sp": {
    "category": "ANALYTICS",
    "userDescription": "Stores a server-generated unique identifier that is sent with all subsequent tracking events for the same user"
  },
  "_sp_id.*": {
    "category": "ANALYTICS",
    "userDescription": "Stores user information that is created when a user first visits a site and updated on subsequent visits. It is used to identify users and analyse the users activity across a domain"
  },
  "_sp_ses.*": {
    "category": "ANALYTICS",
    "userDescription": "Used to identify if the user is in an active session on a site or if this is a new session for a user"
  },
  "_hjIncludedInSessionSample_*": {
    "category": "ANALYTICS",
    "userDescription": "Used to determine if a user is included in the data sampling"
  },
  "_hjSession_*": {
    "category": "ANALYTICS",
    "userDescription": "Holds current session data for Hotjar"
  },
  "_hjSessionUser_*": {
    "category": "ANALYTICS",
    "userDescription": "Ensures Hotjar data from subsequent visits to the same site are attributed to the same user"
  },
  "_hjAbsoluteSessionInProgress": {
    "category": "ANALYTICS",
    "userDescription": "Used by Hotjar to detect the first pageview session of a user"
  },
  "optimizelyEndUserId": {
    "category": "ANALYTICS",
    "userDescription": "Set by Optimizely Web Experimentation, stores a visitor's unique Optimizely Experimentation identifier."
  },
  "_ttp": {
    "category": "MARKETING",
    "userDescription": "Used to measure performance of ad campaigns and personalise user experience"
  },
  "_tt_enable_cookie": {
    "category": "MARKETING",
    "userDescription": "Used to measure performance of ad campaigns and personalise user experience"
  },
  "_fbp": {
    "category": "MARKETING",
    "userDescription": "Used to measure performance of ad campaigns and personalise user experience"
  },
  "wd": {
    "category": "MARKETING",
    "userDescription": "These cookies help deliver an optimal experience for your device's screen"
  },
  "usida": {
    "category": "MARKETING",
    "userDescription": "Collects a combination of the user’s browser and unique identifier, used to tailor advertising to users"
  },
  "datr": {
    "category": "MARKETING",
    "userDescription": "Fraud prevention"
  },
  "_tq_id.TV*": {
    "category": "MARKETING",
    "userDescription": "To measure impressions, reach and outcomes across linear and digital TV"
  },
  "_uetsid": {
    "category": "MARKETING",
    "userDescription": "Bing Ads sets this cookie to engage with a user that has previously visited the website."
  },
  "_uetvid": {
    "category": "MARKETING",
    "userDescription": "Bing Ads sets this cookie to engage with a user that has previously visited the website."
  },
  "MUID": {
    "category": "MARKETING",
    "userDescription": "Microsoft User Identifier tracking cookie used by Bing Ads"
  },
  "_rdt_uuid": {
    "category": "MARKETING",
    "userDescription": "Used to track visitors on multiple websites, in order to present relevant advertisement based on the visitor's preferences."
  },
  "IDE": {
    "category": "MARKETING",
    "userDescription": "Used to show Google ads on non-Google sites"
  },
  "ar_debug": {
    "category": "MARKETING",
    "userDescription": "To store and track conversions"
  },
  "NID": {
    "category": "STRICTLY_NECESSARY",
    "userDescription": "Used by Google to remember your preferences and other information"
  },
  "A1": {
    "category": "MARKETING",
    "userDescription": "Used for providing Yahoo consumer services"
  },
  "A1S": {
    "category": "MARKETING",
    "userDescription": "Used for providing Yahoo consumer services"
  },
  "A3": {
    "category": "MARKETING",
    "userDescription": "Ads targeting cookie for Yahoo"
  },
  "_pinterest_ct_ua": {
    "category": "MARKETING",
    "userDescription": "Groups actions for users who cannot be identified by Pinterest."
  },
  "gdId": {
    "category": "MARKETING",
    "userDescription": "The cookie ensures that the most relevant job postings are shown to the specific user."
  },
  "gdsid": {
    "category": "MARKETING",
    "userDescription": "The cookie ensures that the most relevant job postings are shown to the specific user"
  },
  "trs": {
    "category": "MARKETING",
    "userDescription": "The cookie ensures that the most relevant job postings are shown to the specific user"
  },
  "GSESSIONID": {
    "category": "MARKETING",
    "userDescription": "Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user"
  },
  "JSESSIONID": {
    "category": "MARKETING",
    "userDescription": "Preserves users states across page requests"
  },
  "asst": {
    "category": "MARKETING",
    "userDescription": "Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user."
  },
  "__cf_bm": {
    "category": "MARKETING",
    "userDescription": "This cookie is used to distinguish between humans and bots"
  },
  "_cfuvid": {
    "category": "MARKETING",
    "userDescription": "This cookie is a part of the services provided by Cloudflare"
  },
  "cass": {
    "category": "MARKETING",
    "userDescription": "Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user"
  },
  "__smToken": {
    "category": "MARKETING",
    "userDescription": "Used to verify whether you are logged into Sumo or not"
  },
  "__smVID": {
    "category": "MARKETING",
    "userDescription": "Used for sign-up prompt purposes"
  }
}